import styled from 'styled-components'

export default styled.section`
  display: flex;
  flex-direction: column;
  position: absolute;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(104, 116, 148, 0.12);
  max-height: 245px;
  overflow-Y: scroll;
  overflow-x: hidden;
  width: 206px;
  position: fixed;
  z-index: 9999;
`
